require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021.json") })
        }
      }, "path---relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021!./.cache/json/relazioni-e-conferenze-matteo-iannello-architettura-scolastica-nel-cantone-ticino-iuav-venezia-3-dicembre-2021.json
// module id = 707
// module chunks = 231608221292675